module.exports = __webpack_public_path__ + "img/star.45be3194.svg";